import React from 'react'
import _, { filter, includes, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import {
  Tabs,
  Tab,
  TabButtons,
  Row,
  Col,
  Alert,
  ActionButton,
  Button,
  Tip
} from 'camino-react'

import { simpleHtmlFormat } from 'Utilities/StringManipulator'
import Resolve from 'Components/Problems/Resolve'
import Details from 'Components/Problems/Details'
import AssociatedTickets from 'Components/Problems/AssociatedTickets'
import AssociatedTimesheets from 'Components/Problems/AssociatedTimesheets'
import NoticesModal from 'Components/Notices/NoticesModal/NoticesModal'
import Tasks from 'Components/Problems/Tasks'
import CSIShow from '../CSI/CSIShow'
import Reject from '../Reject'
import AssociatedChangeRequests from '../AssociatedChangeRequests'

class ProblemShow extends React.Component {
  constructor (props) {
    super(props)

    const { problem, open: problemIsOpen, csi, tasks } = props

    this.state = {
      problem,
      problemIsOpen,
      currentTab: 'problem',
      alert: null,
      csi,
      newCsi: [],
      tasks,
      displayCloseModal: false,
      displayRejectModal: false
    }

    this.policy = this.policy.bind(this)
    this.hasRole = this.hasRole.bind(this)
    this.setAlert = this.setAlert.bind(this)
    this.updateProblem = this.updateProblem.bind(this)
  }

  setAlert (text, type) {
    if (_.isEmpty(text) || _.isEmpty(type)) {
      this.setState({ alert: null })
      return
    }

    this.setState({
      alert: {
        text: simpleHtmlFormat(text),
        type
      }
    })
  }

  setCurrentTab (currentTab) {
    this.setState({ currentTab })
  }

  hasRole (...args) {
    const { roles } = this.props

    return _.get(roles, args)
  }

  updateProblem (problem) {
    this.setState({ problem })
  }

  tabClassNames (tabName) {
    const { currentTab } = this.state
    const htmlClasses = ['tabs__links']

    if (currentTab === tabName) { htmlClasses.push('tabs__links--active') }

    return _.join(htmlClasses, ' ')
  }

  policy (...args) {
    const { policies } = this.props

    return _.get(policies, args)
  }

  closeProblemModal = () => (
    this.setState({ problemIsOpen: false })
  )

  render () {
    const {
      policy,
      hasRole,
      setAlert,
      updateProblem,
      closeProblemModal
    } = this
    const {
      paths,
      tickets,
      hasNotices,
      problemNotices,
      attachmentAdmin,
      usersOptions,
      policies
    } = this.props
    const {
      alert,
      problemIsOpen,
      currentTab,
      problem,
      csi,
      newCsi,
      tasks,
      displayCloseModal,
      displayRejectModal
    } = this.state

    const tab = key => ({
      hidden: currentTab !== key,
      props: {
        onClick: () => this.setCurrentTab(key),
        className: this.tabClassNames(key),
        selected: currentTab === key
      }
    })
    const canSubmit = !policy('problem', 'submit') || includes(['Submitted', 'Approved', 'Closed', 'Rejected'], problem.status)
    const problemActions = [
      {
        text: 'Submit',
        href: paths.submitProblemPath,
        method: 'PATCH',
        confirm: 'Are you sure to submit problem?',
        disabled: canSubmit
      },
      {
        text: 'Approve',
        href: paths.approveProblemPath,
        method: 'PATCH',
        confirm: 'Are you sure to approve problem?',
        disabled: !policy('problem', 'approve') || includes(['Approved', 'Closed', 'Rejected'], problem.status)
      },
      {
        text: 'Reject',
        onClick: () => this.setState({ displayRejectModal: true }),
        disabled: !policy('problem', 'reject') || includes(['Closed', 'Rejected'], problem.status)
      },
      {
        text: (<Tip content={`Please ensure you have recorded a root cause,
        corrective action, preventive action,
        outcome and all tasks are completed before closing the problem`}>
          <span>Close</span>
        </Tip>),
        onClick: () => this.setState({ displayCloseModal: true }),
        disabled: !policy('problem', 'close') || !isEmpty(filter(tasks, ['completed_at', null])) || includes(['Closed', 'Rejected'], problem.status)
      },
      {
        text: 'Open',
        href: paths.openProblemPath,
        method: 'PATCH',
        confirm: 'Are you sure to open problem?',
        disabled: !policy('problem', 'open') && !includes(['Closed', 'Rejected'], problem.status)
      }
    ]

    return (
      <div>
        {hasNotices && hasRole('employee') && (
          <NoticesModal
            itemType="problem"
            itemId={problem.id}
            problemNotices={problemNotices}
            problemId={problem.id}
          />
        )}
        <Tabs>
          <Tab {...tab('problem').props}>
            Problem
          </Tab>
          <Tab {...tab('tasks').props}>
            Tasks
          </Tab>
          <Tab {...tab('associated tickets').props}>
            Associated tickets
          </Tab>
          <Tab {...tab('associated timesheets').props}>
            Associated timesheets
          </Tab>
          <Tab {...tab('associated changerequests').props}>
            Associated Change Requests
          </Tab>
          <TabButtons>
            <ActionButton
              size="compact"
              color="outline-secondary"
              className="button button--outline"
              actions={problemActions}
            >
              ACTIONS
            </ActionButton>
          </TabButtons>

          <Resolve
            {...this.props}
            paths={paths}
            setAlert={setAlert}
            closeProblemModal={closeProblemModal}
            tickets={tickets}
            problem={problem}
            showModal={displayCloseModal}
            closeModal={() => this.setState({ displayCloseModal: false })}
          />

          <Reject
            {...this.props}
            paths={paths}
            problem={problem}
            showModal={displayRejectModal}
            closeModal={() => this.setState({ displayRejectModal: false })}
          />
        </Tabs>

        <Row>
          <Col width={15}>
            { alert && (
              <Alert type={alert.type}>
                <span>
                  {alert.text}
                </span>
              </Alert>
            )}

            <Details
              {...this.props}
              problem={problem}
              policy={policy}
              setAlert={setAlert}
              updateProblem={updateProblem}
              hidden={tab('problem').hidden}
              attachmentAdmin={attachmentAdmin}
            />

            <AssociatedTickets
              {...this.props}
              problem={problem}
              policy={policy}
              setAlert={setAlert}
              paths={paths}
              hidden={tab('associated tickets').hidden}
              csi={csi}
            />

            <AssociatedTimesheets
              {...this.props}
              problem={problem}
              policy={policy}
              paths={paths}
              hidden={tab('associated timesheets').hidden}
              setAlert={setAlert}
            />

            <AssociatedChangeRequests
              changeRequests={problem.change_requests}
              policy={policy}
              hidden={tab('associated changerequests').hidden}
            />

            <Tasks
              {...this.props}
              problem={problem}
              policy={policy}
              paths={paths}
              hidden={tab('tasks').hidden}
              setAlert={setAlert}
              updateTasksState={value => this.setState({ tasks: value })}
            />

            <CSIShow
              {...this.props}
              csi={csi}
              newCsi={newCsi}
              hidden={tab('tasks').hidden}
              updateCSIState={value => this.setState({ newCsi: value })}
              usersOptions={usersOptions}
              manageCSITasks={policy('problem', 'manageCSITasks')}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

ProblemShow.propTypes = {
  paths: PropTypes.shape({
    apiProblemTimesheetsPath: PropTypes.string.isRequired,
    apiProblemCommentsPath: PropTypes.string.isRequired,
    apiProblemsUnassignedTicketsPath: PropTypes.string.isRequired
  }).isRequired
}

export default ProblemShow
